import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from './Logo';
import { LangSwitcher } from './LangSwitcher';
import { APP_URL } from '@/config';
import { trackEvent } from '@/analytics';

// Barra superior fija: transparente arriba, con fondo al hacer scroll.
export function Navbar() {
  const { t } = useTranslation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? 'border-b border-clay-300/10 bg-clay-950/80 backdrop-blur-md' : ''
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
        <a href="#top" aria-label="Bestigium">
          <Logo />
        </a>
        <div className="hidden items-center gap-8 md:flex">
          <a href="#features" className="text-sm text-clay-200 transition hover:text-amber-glow">
            {t('nav.features')}
          </a>
          <a href="#map" className="text-sm text-clay-200 transition hover:text-amber-glow">
            {t('nav.map')}
          </a>
          <a href="#join" className="text-sm text-clay-200 transition hover:text-amber-glow">
            {t('nav.join')}
          </a>
        </div>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          <a
            href={APP_URL}
            onClick={() => trackEvent('cta-app-click', { from: 'navbar' })}
            className="btn-primary !px-5 !py-2 text-sm"
          >
            {t('nav.explore')}
          </a>
        </div>
      </nav>
    </header>
  );
}
